import { rxDispatch } from './rx-stores';
import SessionStore from './rx-stores/session';
import { SessionStatus, SessionActionTypes } from './types/session';
import { SenseiJwtPayload } from './types/jwt';
import hashHistory from './history';

import jwtDecode from 'jwt-decode';

export let onStartup = () => {
  redirectToCorrectOrigin();

  const next = window.localStorage.loginNext || '/';

  const session = SessionStore.imperativelyGetValue();
  if (session.status === SessionStatus.LOGGED_IN) {
    // Check auth0 access token for expiration
    try {
      const decoded = jwtDecode<SenseiJwtPayload>(session.token);
      const expiresTime = new Date(decoded.exp * 1000);

      if (new Date() > expiresTime) {
        rxDispatch({ type: SessionActionTypes.SESSION_CLEAR_TOKEN });
        onStartup();
      }

      if (window.location.hash.match(/^#\/?access_token=([^&]+)/)) {
        hashHistory.replace(next);
      }
    } catch (e) {
      console.warn(`Failed to decode token: {e}`);
    }

    return;
  }

  const locationHash = window.location.hash;
  const accessTokenMatch = locationHash.match(/^#\/?access_token=([^&]+)/);

  // If the hash has an OAuth access token, exchange it for an API token
  if (accessTokenMatch) {
    let accessToken = accessTokenMatch[1];
    rxDispatch({
      type: SessionActionTypes.SESSION_SET_TOKEN,
      token: accessToken,
    });

    hashHistory.replace(next);
    return;
  }

  if (!window.location.hash.includes('/login')) {
    const next = window.location.hash.replace(/^#/, '').replace(/\/*$/, '');
    if (next.length > 0) {
      hashHistory.replace(`/login?next=${encodeURIComponent(next)}`);
    } else {
      hashHistory.replace(`/login`);
    }
  }
};

// If the originating origin of the login request was not this sensei instance, then redirect
// to the originating sensei instance. Ie, a user tried to login via oauth on a preview link,
// and it redirected to staging sensei, not the preview link sensei. So, redirect back to the
// preview link.
function redirectToCorrectOrigin() {
  const loginOAuthOrigin = window.localStorage.loginOAuthOrigin;
  delete window.localStorage.loginOAuthOrigin;

  const hashIndex = window.location.href.indexOf('#');
  const currentOrigin = window.location.href
    .slice(0, hashIndex)
    .replace(/\/$/, '');

  if (loginOAuthOrigin && loginOAuthOrigin !== currentOrigin) {
    const hashIndex = window.location.href.indexOf('#');
    const newHref = loginOAuthOrigin + window.location.href.slice(hashIndex);

    console.warn(
      `Redirecting from ${window.location.href} to ${newHref} because oauth callback hit a different domain than it originated at`,
    );
    window.location.href = newHref;
  }
}
